import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../../../algorithms/date";

export default function MultiSelectTable({
	items = [],
	headers = {},
	keyToSelect = "id",
	id = "table",
	setSelectedData,
	customField = { tag: "date", field: "Name" },
	customColumnTemplates = {}, // Accept custom templates for specific columns
	dt,
}) {
	const [selectedProducts, setSelectedProducts] = useState([]);

	const onRowSelect = (event) => {
		console.log(event.data);
	};

	React.useEffect(() => {
		if (setSelectedData) {
			setSelectedData(selectedProducts);
		}
	}, [selectedProducts]);

	// Date template for fields requiring formatted dates
	const dateTemplate = (rowData, data) => {
		return (
			<p>{formatDate(rowData[data.column.props.field]?.split("T")[0] || "")}</p>
		);
	};

	// Default template for status column
	const statusTemplate = (rowData, data) => {
		const status = rowData[data.column.props.field];
		const statusStyles = {
			Verified: { color: "green" },
			Rejected: { color: "red" },
			Pending: { color: "orange" },
		};
		return (
			<span style={statusStyles[status] || {}}>{status || "Unknown"}</span>
		);
	};

	return (
		<DataTable
			id={id}
			paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
			currentPageReportTemplate="Rows per page"
			value={items}
			selection={selectedProducts}
			onSelectionChange={(e) => setSelectedProducts(e.value)}
			dataKey={keyToSelect}
			paginator
			ref={dt}
			rowsPerPageOptions={[10, 20, 50]}
			rows={10}
			sortMode="multiple"
			sortField="name"
			sortOrder={1}
			removableSort
			stripedRows={true}
			showGridlines
			tableStyle={{
				minWidth: "50rem",
				borderWidth: 2,
				borderColor: "#E6E6E6",
			}}
			onRowSelect={onRowSelect}
		>
			<Column
				selectionMode="multiple"
				bodyStyle={{
					backgroundColor: "lightgray",
				}}
				headerClassName="text-center font-bold"
				headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
			></Column>
			{Object.keys(headers).map((data, key) => {
				// Apply custom template if defined for the column
				if (customColumnTemplates[data]) {
					return (
						<Column
							field={data}
							header={headers[data]}
							sortable
							body={(rowData, meta) =>
								customColumnTemplates[data](rowData, meta)
							}
							headerStyle={{
								backgroundColor: "#facc15",
								color: "black",
							}}
							headerClassName="text-center font-bold"
							key={key}
						></Column>
					);
				}

				// Default behavior for date field
				if (data === customField.field && customField.tag === "date") {
					return (
						<Column
							field={data}
							header={headers[data]}
							sortable
							body={dateTemplate}
							headerStyle={{
								backgroundColor: "#facc15",
								color: "black",
							}}
							headerClassName="text-center font-bold"
							key={key}
						></Column>
					);
				}

				// Default column rendering
				return (
					<Column
						field={data}
						header={headers[data]}
						sortable
						headerStyle={{
							backgroundColor: "#facc15",
							color: "black",
						}}
						headerClassName="text-center font-bold"
						key={key}
					></Column>
				);
			})}
		</DataTable>
	);
}
